import type { EmailLog, EmailLogResponse, SendEmailInput } from '@peles/shared';
import { apiClient } from './client';

export async function sendEmail(input: SendEmailInput): Promise<EmailLog> {
  const { data } = await apiClient.post<EmailLog>('/admin/emails/send', input);
  return data;
}

export async function getEmailLogs(filters?: {
  status?: string;
  template?: string;
  to?: string;
  limit?: number;
  offset?: number;
}): Promise<EmailLogResponse> {
  const { data } = await apiClient.get<EmailLogResponse>('/admin/emails/logs', {
    params: filters,
  });
  return data;
}
